import type { PropsWithChildren } from 'react';
import * as React from 'react';
import type { ItemProps, ItemSelectionProps } from './types';

import { PillItem } from './PillItem';
import { InputItem } from './InputItem';
import { IconItem } from './IconItem';

import { ItemContext, ItemContextProvider } from './context';
import { SheetItem } from '@/scopes/search/components/QuickSearchBar/Item/SheetItem';

export function Root({ children, ...rest }: PropsWithChildren<ItemProps>) {
  const { type, responsive } = React.useContext(ItemContext);

  return <ItemContextProvider value={{ type, responsive, ...rest }}>{children}</ItemContextProvider>;
}

export function AsPopover({ children, ...rest }: PropsWithChildren<ItemSelectionProps>) {
  const { type } = React.useContext(ItemContext);

  if (type !== 'popover') return null;

  return <PillItem {...rest}>{children}</PillItem>;
}

export function AsDialog({ children, ...rest }: PropsWithChildren<ItemSelectionProps>) {
  const { type } = React.useContext(ItemContext);

  if (type !== 'dialog') return null;

  return <InputItem {...rest}>{children}</InputItem>;
}

export function AsIcon({ children, ...rest }: PropsWithChildren<ItemSelectionProps>) {
  const { type } = React.useContext(ItemContext);

  if (type !== 'icon') return null;

  return <IconItem {...rest}>{children}</IconItem>;
}

export function AsSheet({ children, ...rest }: PropsWithChildren<ItemSelectionProps>) {
  const { type } = React.useContext(ItemContext);

  if (type !== 'sheet') return null;

  return <SheetItem {...rest}>{children}</SheetItem>;
}
